(function (global, factory) {
  typeof exports === 'object' && typeof module !== 'undefined' ? factory(exports) :
  typeof define === 'function' && define.amd ? define(['exports'], factory) :
  (global = typeof globalThis !== 'undefined' ? globalThis : global || self, factory(global.Icon = {}));
}(this, (function (exports) { 'use strict';

  function _arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
    return n;
  }
  function _arrayWithHoles(r) {
    if (Array.isArray(r)) return r;
  }
  function _assertThisInitialized(e) {
    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
  }
  function _callSuper(t, o, e) {
    return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e));
  }
  function _classCallCheck(a, n) {
    if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
  }
  function _defineProperties(e, r) {
    for (var t = 0; t < r.length; t++) {
      var o = r[t];
      o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
    }
  }
  function _createClass(e, r, t) {
    return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
      writable: !1
    }), e;
  }
  function _getPrototypeOf(t) {
    return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) {
      return t.__proto__ || Object.getPrototypeOf(t);
    }, _getPrototypeOf(t);
  }
  function _inherits(t, e) {
    if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
    t.prototype = Object.create(e && e.prototype, {
      constructor: {
        value: t,
        writable: !0,
        configurable: !0
      }
    }), Object.defineProperty(t, "prototype", {
      writable: !1
    }), e && _setPrototypeOf(t, e);
  }
  function _isNativeReflectConstruct() {
    try {
      var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    } catch (t) {}
    return (_isNativeReflectConstruct = function () {
      return !!t;
    })();
  }
  function _iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
      var e,
        n,
        i,
        u,
        a = [],
        f = !0,
        o = !1;
      try {
        if (i = (t = t.call(r)).next, 0 === l) {
          if (Object(t) !== t) return;
          f = !1;
        } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
      } catch (r) {
        o = !0, n = r;
      } finally {
        try {
          if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return;
        } finally {
          if (o) throw n;
        }
      }
      return a;
    }
  }
  function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  function _possibleConstructorReturn(t, e) {
    if (e && ("object" == typeof e || "function" == typeof e)) return e;
    if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
    return _assertThisInitialized(t);
  }
  function _setPrototypeOf(t, e) {
    return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) {
      return t.__proto__ = e, t;
    }, _setPrototypeOf(t, e);
  }
  function _slicedToArray(r, e) {
    return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest();
  }
  function _toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
      var i = e.call(t, r || "default");
      if ("object" != typeof i) return i;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
  }
  function _toPropertyKey(t) {
    var i = _toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
  }
  function _unsupportedIterableToArray(r, a) {
    if (r) {
      if ("string" == typeof r) return _arrayLikeToArray(r, a);
      var t = {}.toString.call(r).slice(8, -1);
      return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
    }
  }

  function noop() { }
  function run(fn) {
      return fn();
  }
  function blank_object() {
      return Object.create(null);
  }
  function run_all(fns) {
      fns.forEach(run);
  }
  function is_function(thing) {
      return typeof thing === 'function';
  }
  function safe_not_equal(a, b) {
      return a != a ? b == b : a !== b || ((a && typeof a === 'object') || typeof a === 'function');
  }
  function is_empty(obj) {
      return Object.keys(obj).length === 0;
  }

  function append(target, node) {
      target.appendChild(node);
  }
  function insert(target, node, anchor) {
      target.insertBefore(node, anchor || null);
  }
  function detach(node) {
      node.parentNode.removeChild(node);
  }
  function element(name) {
      return document.createElement(name);
  }
  function text(data) {
      return document.createTextNode(data);
  }
  function empty() {
      return text('');
  }
  function attr(node, attribute, value) {
      if (value == null)
          node.removeAttribute(attribute);
      else if (node.getAttribute(attribute) !== value)
          node.setAttribute(attribute, value);
  }
  function children(element) {
      return Array.from(element.childNodes);
  }
  function toggle_class(element, name, toggle) {
      element.classList[toggle ? 'add' : 'remove'](name);
  }
  function custom_event(type, detail) {
      const e = document.createEvent('CustomEvent');
      e.initCustomEvent(type, false, false, detail);
      return e;
  }
  class HtmlTag {
      constructor(anchor = null) {
          this.a = anchor;
          this.e = this.n = null;
      }
      m(html, target, anchor = null) {
          if (!this.e) {
              this.e = element(target.nodeName);
              this.t = target;
              this.h(html);
          }
          this.i(anchor);
      }
      h(html) {
          this.e.innerHTML = html;
          this.n = Array.from(this.e.childNodes);
      }
      i(anchor) {
          for (let i = 0; i < this.n.length; i += 1) {
              insert(this.t, this.n[i], anchor);
          }
      }
      p(html) {
          this.d();
          this.h(html);
          this.i(this.a);
      }
      d() {
          this.n.forEach(detach);
      }
  }

  let current_component;
  function set_current_component(component) {
      current_component = component;
  }
  function get_current_component() {
      if (!current_component)
          throw new Error('Function called outside component initialization');
      return current_component;
  }
  function beforeUpdate(fn) {
      get_current_component().$$.before_update.push(fn);
  }
  function onMount(fn) {
      get_current_component().$$.on_mount.push(fn);
  }
  function onDestroy(fn) {
      get_current_component().$$.on_destroy.push(fn);
  }
  function createEventDispatcher() {
      const component = get_current_component();
      return (type, detail) => {
          const callbacks = component.$$.callbacks[type];
          if (callbacks) {
              // TODO are there situations where events could be dispatched
              // in a server (non-DOM) environment?
              const event = custom_event(type, detail);
              callbacks.slice().forEach(fn => {
                  fn.call(component, event);
              });
          }
      };
  }

  const dirty_components = [];
  const binding_callbacks = [];
  const render_callbacks = [];
  const flush_callbacks = [];
  const resolved_promise = Promise.resolve();
  let update_scheduled = false;
  function schedule_update() {
      if (!update_scheduled) {
          update_scheduled = true;
          resolved_promise.then(flush);
      }
  }
  function add_render_callback(fn) {
      render_callbacks.push(fn);
  }
  let flushing = false;
  const seen_callbacks = new Set();
  function flush() {
      if (flushing)
          return;
      flushing = true;
      do {
          // first, call beforeUpdate functions
          // and update components
          for (let i = 0; i < dirty_components.length; i += 1) {
              const component = dirty_components[i];
              set_current_component(component);
              update(component.$$);
          }
          set_current_component(null);
          dirty_components.length = 0;
          while (binding_callbacks.length)
              binding_callbacks.pop()();
          // then, once components are updated, call
          // afterUpdate functions. This may cause
          // subsequent updates...
          for (let i = 0; i < render_callbacks.length; i += 1) {
              const callback = render_callbacks[i];
              if (!seen_callbacks.has(callback)) {
                  // ...so guard against infinite loops
                  seen_callbacks.add(callback);
                  callback();
              }
          }
          render_callbacks.length = 0;
      } while (dirty_components.length);
      while (flush_callbacks.length) {
          flush_callbacks.pop()();
      }
      update_scheduled = false;
      flushing = false;
      seen_callbacks.clear();
  }
  function update($$) {
      if ($$.fragment !== null) {
          $$.update();
          run_all($$.before_update);
          const dirty = $$.dirty;
          $$.dirty = [-1];
          $$.fragment && $$.fragment.p($$.ctx, dirty);
          $$.after_update.forEach(add_render_callback);
      }
  }
  const outroing = new Set();
  function transition_in(block, local) {
      if (block && block.i) {
          outroing.delete(block);
          block.i(local);
      }
  }
  function mount_component(component, target, anchor, customElement) {
      const { fragment, on_mount, on_destroy, after_update } = component.$$;
      fragment && fragment.m(target, anchor);
      if (!customElement) {
          // onMount happens before the initial afterUpdate
          add_render_callback(() => {
              const new_on_destroy = on_mount.map(run).filter(is_function);
              if (on_destroy) {
                  on_destroy.push(...new_on_destroy);
              }
              else {
                  // Edge case - component was destroyed immediately,
                  // most likely as a result of a binding initialising
                  run_all(new_on_destroy);
              }
              component.$$.on_mount = [];
          });
      }
      after_update.forEach(add_render_callback);
  }
  function destroy_component(component, detaching) {
      const $$ = component.$$;
      if ($$.fragment !== null) {
          run_all($$.on_destroy);
          $$.fragment && $$.fragment.d(detaching);
          // TODO null out other refs, including component.$$ (but need to
          // preserve final state?)
          $$.on_destroy = $$.fragment = null;
          $$.ctx = [];
      }
  }
  function make_dirty(component, i) {
      if (component.$$.dirty[0] === -1) {
          dirty_components.push(component);
          schedule_update();
          component.$$.dirty.fill(0);
      }
      component.$$.dirty[(i / 31) | 0] |= (1 << (i % 31));
  }
  function init(component, options, instance, create_fragment, not_equal, props, dirty = [-1]) {
      const parent_component = current_component;
      set_current_component(component);
      const $$ = component.$$ = {
          fragment: null,
          ctx: null,
          // state
          props,
          update: noop,
          not_equal,
          bound: blank_object(),
          // lifecycle
          on_mount: [],
          on_destroy: [],
          on_disconnect: [],
          before_update: [],
          after_update: [],
          context: new Map(parent_component ? parent_component.$$.context : options.context || []),
          // everything else
          callbacks: blank_object(),
          dirty,
          skip_bound: false
      };
      let ready = false;
      $$.ctx = instance
          ? instance(component, options.props || {}, (i, ret, ...rest) => {
              const value = rest.length ? rest[0] : ret;
              if ($$.ctx && not_equal($$.ctx[i], $$.ctx[i] = value)) {
                  if (!$$.skip_bound && $$.bound[i])
                      $$.bound[i](value);
                  if (ready)
                      make_dirty(component, i);
              }
              return ret;
          })
          : [];
      $$.update();
      ready = true;
      run_all($$.before_update);
      // `false` as a special case of no DOM component
      $$.fragment = create_fragment ? create_fragment($$.ctx) : false;
      if (options.target) {
          if (options.hydrate) {
              const nodes = children(options.target);
              // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
              $$.fragment && $$.fragment.l(nodes);
              nodes.forEach(detach);
          }
          else {
              // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
              $$.fragment && $$.fragment.c();
          }
          if (options.intro)
              transition_in(component.$$.fragment);
          mount_component(component, options.target, options.anchor, options.customElement);
          flush();
      }
      set_current_component(parent_component);
  }
  /**
   * Base class for Svelte components. Used when dev=false.
   */
  class SvelteComponent {
      $destroy() {
          destroy_component(this, 1);
          this.$destroy = noop;
      }
      $on(type, callback) {
          const callbacks = (this.$$.callbacks[type] || (this.$$.callbacks[type] = []));
          callbacks.push(callback);
          return () => {
              const index = callbacks.indexOf(callback);
              if (index !== -1)
                  callbacks.splice(index, 1);
          };
      }
      $set($$props) {
          if (this.$$set && !is_empty($$props)) {
              this.$$.skip_bound = true;
              this.$$set($$props);
              this.$$.skip_bound = false;
          }
      }
  }

  function createCommonjsModule(fn, basedir, module) {
  	return module = {
  		path: basedir,
  		exports: {},
  		require: function (path, base) {
  			return commonjsRequire(path, (base === undefined || base === null) ? module.path : base);
  		}
  	}, fn(module, module.exports), module.exports;
  }

  function getAugmentedNamespace(n) {
  	if (n.__esModule) return n;
  	var a = Object.defineProperty({}, '__esModule', {value: true});
  	Object.keys(n).forEach(function (k) {
  		var d = Object.getOwnPropertyDescriptor(n, k);
  		Object.defineProperty(a, k, d.get ? d : {
  			enumerable: true,
  			get: function () {
  				return n[k];
  			}
  		});
  	});
  	return a;
  }

  function commonjsRequire () {
  	throw new Error('Dynamic requires are not currently supported by @rollup/plugin-commonjs');
  }

  /*! *****************************************************************************
  Copyright (c) Microsoft Corporation.

  Permission to use, copy, modify, and/or distribute this software for any
  purpose with or without fee is hereby granted.

  THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
  REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
  AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
  INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
  LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
  OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
  PERFORMANCE OF THIS SOFTWARE.
  ***************************************************************************** */
  /* global Reflect, Promise */

  var extendStatics = function(d, b) {
      extendStatics = Object.setPrototypeOf ||
          ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
          function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
      return extendStatics(d, b);
  };

  function __extends(d, b) {
      extendStatics(d, b);
      function __() { this.constructor = d; }
      d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  }

  var __assign = function() {
      __assign = Object.assign || function __assign(t) {
          for (var s, i = 1, n = arguments.length; i < n; i++) {
              s = arguments[i];
              for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
          }
          return t;
      };
      return __assign.apply(this, arguments);
  };

  function __rest(s, e) {
      var t = {};
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
          t[p] = s[p];
      if (s != null && typeof Object.getOwnPropertySymbols === "function")
          for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
              if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                  t[p[i]] = s[p[i]];
          }
      return t;
  }

  function __decorate(decorators, target, key, desc) {
      var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
      if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
      else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
      return c > 3 && r && Object.defineProperty(target, key, r), r;
  }

  function __param(paramIndex, decorator) {
      return function (target, key) { decorator(target, key, paramIndex); }
  }

  function __metadata(metadataKey, metadataValue) {
      if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
  }

  function __awaiter(thisArg, _arguments, P, generator) {
      function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
      return new (P || (P = Promise))(function (resolve, reject) {
          function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
          function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
          function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
          step((generator = generator.apply(thisArg, _arguments || [])).next());
      });
  }

  function __generator(thisArg, body) {
      var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
      return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
      function verb(n) { return function (v) { return step([n, v]); }; }
      function step(op) {
          if (f) throw new TypeError("Generator is already executing.");
          while (_) try {
              if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
              if (y = 0, t) op = [op[0] & 2, t.value];
              switch (op[0]) {
                  case 0: case 1: t = op; break;
                  case 4: _.label++; return { value: op[1], done: false };
                  case 5: _.label++; y = op[1]; op = [0]; continue;
                  case 7: op = _.ops.pop(); _.trys.pop(); continue;
                  default:
                      if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                      if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                      if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                      if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                      if (t[2]) _.ops.pop();
                      _.trys.pop(); continue;
              }
              op = body.call(thisArg, _);
          } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
          if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
      }
  }

  var __createBinding = Object.create ? (function(o, m, k, k2) {
      if (k2 === undefined) k2 = k;
      Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
  }) : (function(o, m, k, k2) {
      if (k2 === undefined) k2 = k;
      o[k2] = m[k];
  });

  function __exportStar(m, o) {
      for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) __createBinding(o, m, p);
  }

  function __values(o) {
      var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
      if (m) return m.call(o);
      if (o && typeof o.length === "number") return {
          next: function () {
              if (o && i >= o.length) o = void 0;
              return { value: o && o[i++], done: !o };
          }
      };
      throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
  }

  function __read(o, n) {
      var m = typeof Symbol === "function" && o[Symbol.iterator];
      if (!m) return o;
      var i = m.call(o), r, ar = [], e;
      try {
          while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
      }
      catch (error) { e = { error: error }; }
      finally {
          try {
              if (r && !r.done && (m = i["return"])) m.call(i);
          }
          finally { if (e) throw e.error; }
      }
      return ar;
  }

  function __spread() {
      for (var ar = [], i = 0; i < arguments.length; i++)
          ar = ar.concat(__read(arguments[i]));
      return ar;
  }

  function __spreadArrays() {
      for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
      for (var r = Array(s), k = 0, i = 0; i < il; i++)
          for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
              r[k] = a[j];
      return r;
  }
  function __await(v) {
      return this instanceof __await ? (this.v = v, this) : new __await(v);
  }

  function __asyncGenerator(thisArg, _arguments, generator) {
      if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
      var g = generator.apply(thisArg, _arguments || []), i, q = [];
      return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i;
      function verb(n) { if (g[n]) i[n] = function (v) { return new Promise(function (a, b) { q.push([n, v, a, b]) > 1 || resume(n, v); }); }; }
      function resume(n, v) { try { step(g[n](v)); } catch (e) { settle(q[0][3], e); } }
      function step(r) { r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r); }
      function fulfill(value) { resume("next", value); }
      function reject(value) { resume("throw", value); }
      function settle(f, v) { if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]); }
  }

  function __asyncDelegator(o) {
      var i, p;
      return i = {}, verb("next"), verb("throw", function (e) { throw e; }), verb("return"), i[Symbol.iterator] = function () { return this; }, i;
      function verb(n, f) { i[n] = o[n] ? function (v) { return (p = !p) ? { value: __await(o[n](v)), done: n === "return" } : f ? f(v) : v; } : f; }
  }

  function __asyncValues(o) {
      if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
      var m = o[Symbol.asyncIterator], i;
      return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i);
      function verb(n) { i[n] = o[n] && function (v) { return new Promise(function (resolve, reject) { v = o[n](v), settle(resolve, reject, v.done, v.value); }); }; }
      function settle(resolve, reject, d, v) { Promise.resolve(v).then(function(v) { resolve({ value: v, done: d }); }, reject); }
  }

  function __makeTemplateObject(cooked, raw) {
      if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
      return cooked;
  }
  var __setModuleDefault = Object.create ? (function(o, v) {
      Object.defineProperty(o, "default", { enumerable: true, value: v });
  }) : function(o, v) {
      o["default"] = v;
  };

  function __importStar(mod) {
      if (mod && mod.__esModule) return mod;
      var result = {};
      if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
      __setModuleDefault(result, mod);
      return result;
  }

  function __importDefault(mod) {
      return (mod && mod.__esModule) ? mod : { default: mod };
  }

  function __classPrivateFieldGet(receiver, privateMap) {
      if (!privateMap.has(receiver)) {
          throw new TypeError("attempted to get private field on non-instance");
      }
      return privateMap.get(receiver);
  }

  function __classPrivateFieldSet(receiver, privateMap, value) {
      if (!privateMap.has(receiver)) {
          throw new TypeError("attempted to set private field on non-instance");
      }
      privateMap.set(receiver, value);
      return value;
  }

  var tslib_es6 = /*#__PURE__*/Object.freeze({
    __proto__: null,
    __extends: __extends,
    get __assign () { return __assign; },
    __rest: __rest,
    __decorate: __decorate,
    __param: __param,
    __metadata: __metadata,
    __awaiter: __awaiter,
    __generator: __generator,
    __createBinding: __createBinding,
    __exportStar: __exportStar,
    __values: __values,
    __read: __read,
    __spread: __spread,
    __spreadArrays: __spreadArrays,
    __await: __await,
    __asyncGenerator: __asyncGenerator,
    __asyncDelegator: __asyncDelegator,
    __asyncValues: __asyncValues,
    __makeTemplateObject: __makeTemplateObject,
    __importStar: __importStar,
    __importDefault: __importDefault,
    __classPrivateFieldGet: __classPrivateFieldGet,
    __classPrivateFieldSet: __classPrivateFieldSet
  });

  var Cache_1 = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", { value: true });
  /**
   * Simple cache implementation
   */
  var Cache = /** @class */ (function () {
      function Cache() {
          this.data = {};
          this.pending = {};
      }
      Cache.prototype.put = function (key, value) {
          var previousValue = this.data[key];
          this.data[key] = value;
          return previousValue;
      };
      Cache.prototype.get = function (key) {
          return this.data[key];
      };
      Cache.prototype.remove = function (key) {
          var previousValue = this.data[key];
          delete this.data[key];
          return previousValue;
      };
      Cache.prototype.removeAll = function () {
          this.data = {};
      };
      /**
       * Gets a value from the cache or invokes the callback to populate the value
       * with the result of a promise. If invoked multiple times, it will return the promise
       * of the first pending invocation, preventing multiple invocations while a promise is resolving.
       *
       * @param key cache key
       * @param callback returns a Promise to populate the cache with
       * @returns Promise<*> a promise with the cached value
       */
      Cache.prototype.refreshIfAbsent = function (key, callback) {
          if (this.data.hasOwnProperty(key)) {
              return Promise.resolve(this.data[key]);
          }
          return this.refresh(key, callback);
      };
      /**
       * Invokes the callback to populate the value with the result of a promise.
       * If invoked multiple times, it will return the promise
       * of the first pending invocation, preventing multiple invocations while a promise is resolving.
       *
       * @param key cache key
       * @param callback returns a Promise to populate the cache with
       * @returns Promise<*> a promise with the cached value
       */
      Cache.prototype.refresh = function (key, callback) {
          var _this = this;
          // Check if the callback is already pending for this key
          var pending = this.pending[key];
          if (pending) {
              return pending;
          }
          pending = callback();
          this.pending[key] = pending;
          return pending.then(function (value) {
              delete _this.pending[key];
              _this.put(key, value);
              return value;
          }).catch(function (error) {
              delete _this.pending[key];
              throw error;
          });
      };
      return Cache;
  }());
  exports.default = Cache;

  });

  var tslib_1 = /*@__PURE__*/getAugmentedNamespace(tslib_es6);

  var Registry_1 = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", { value: true });
  exports.SERVICE_REGISTRY_PATH = void 0;

  var Cache_1$1 = tslib_1.__importDefault(Cache_1);
  exports.SERVICE_REGISTRY_PATH = '/api/portal/v2/client/config';
  var PORTAL_SERVICE_NAME = 'portal_service';
  var PORTAL_CLIENT_CONFIG_PATH = 'client/config';
  var DEFAULT_CONFIG = {
      host: '',
      cache: new Cache_1$1.default(),
  };
  var Registry = /** @class */ (function () {
      function Registry(config) {
          if (config === void 0) { config = DEFAULT_CONFIG; }
          this.config = tslib_1.__assign(tslib_1.__assign({}, DEFAULT_CONFIG), config);
      }
      // Get the underlying registry cache
      Registry.prototype.getCache = function () {
          return this.config.cache;
      };
      Registry.prototype.getRegistry = function () {
          var _this = this;
          return this.config.cache.refreshIfAbsent('registry', function () {
              var serviceRegistryUrl = _this.getHost();
              serviceRegistryUrl += exports.SERVICE_REGISTRY_PATH;
              var config = {
                  method: 'GET',
                  mode: 'cors',
                  credentials: 'include',
                  headers: {
                      'Content-Type': 'application/json',
                  },
              };
              return fetch(serviceRegistryUrl, config).then(function (resp) {
                  if (!resp.ok) {
                      return Promise.reject(resp);
                  }
                  return resp.json().then(function (data) {
                      var dataResponse = tslib_1.__assign({ data: data }, resp);
                      var registry = data.registry;
                      // Optimization - also stuff the client config URL into the cache.
                      // Sometimes, this URL can be different if it's requested from the same domain.
                      var portalService = registry.services[PORTAL_SERVICE_NAME];
                      if (portalService) {
                          var clientConfigUrl = _this.createServiceUrl(portalService, PORTAL_CLIENT_CONFIG_PATH, 2);
                          _this.config.cache.put(clientConfigUrl, dataResponse);
                      }
                      return dataResponse;
                  });
              });
          }).then(function (resp) {
              return resp.data.registry;
          });
      };
      Registry.prototype.getUrl = function (serviceName, path, version) {
          var _this = this;
          if (path === void 0) { path = ''; }
          return this.getRegistry().then(function (data) {
              var service = data.services[serviceName];
              if (service === undefined) {
                  throw new Error("Unable to find service '" + serviceName + "'");
              }
              return service;
          }).then(function (service) {
              return _this.createServiceUrl(service, path, version);
          });
      };
      Registry.prototype.getServiceBaseUrl = function (service, version) {
          var baseUrl = service.base_sv_url;
          if (!baseUrl) {
              // unversioned service - simply return regular service url
              return service.sv_url;
          }
          if (version === undefined) {
              // Use configured version if present
              // if(apiVersions[serviceName]) {
              //  version = apiVersions[serviceName];
              // Fallback to version 1 (keeps backwards comparability and generally safe)
              version = 1;
          }
          return this.joinUrlParts(baseUrl, 'v' + version);
      };
      Registry.prototype.getServiceHostUrl = function (service) {
          // Inspired by https://gist.github.com/jlong/2428561
          var parser = document.createElement('a');
          parser.href = service.sv_url;
          return parser.protocol + "//" + parser.host;
      };
      Registry.prototype.createServiceUrl = function (service, path, version) {
          var base;
          if (path.charAt(0) === '/') {
              // Host absolute URL
              base = this.getServiceHostUrl(service);
          }
          else {
              // Service relative URL
              base = this.getServiceBaseUrl(service, version);
          }
          return this.joinUrlParts(base, path);
      };
      /**
       * Determines the registry host in the following order,
       * 1. Uses the configured host if set
       * 2. If a PrintOS subdomain is detected as the current hostname,
       *    the base domain is returned.
       *    For example, if location.hostname is 'app.www.printos.com',
       *    then 'www.printos.com' is returned.
       * 3. Return an empty string otherwise (resulting in a registry call relative
       *    to the current host).
       */
      Registry.prototype.getHost = function () {
          if (this.config.host) {
              // Ensure https
              if (this.config.host.indexOf('https://') !== 0) {
                  this.config.host = 'https://' + this.config.host;
              }
              return this.config.host;
          }
          return '';
      };
      Registry.prototype.joinUrlParts = function (a, b) {
          if (!b) {
              return a;
          }
          if (b.charAt(0) === '/') {
              // Prevent double slashes by ensuring part b doesn't have a slash
              b = b.substr(1);
          }
          if (a.charAt(a.length - 1) === '/') {
              return a + b;
          }
          return a + '/' + b;
      };
      return Registry;
  }());
  exports.default = Registry;

  });

  var Http_1 = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", { value: true });

  var Registry_1$1 = tslib_1.__importDefault(Registry_1);
  var DEFAULT_CONFIG = {
      registry: new Registry_1$1.default(),
  };
  var Http = /** @class */ (function () {
      function Http(config) {
          if (config === void 0) { config = DEFAULT_CONFIG; }
          this.config = tslib_1.__assign(tslib_1.__assign({}, DEFAULT_CONFIG), config);
          // Use registry cache by default to cache the registry efficiently
          // Use registry cache by default to cache the registry efficiently
          this.config.cache = this.config.cache || this.config.registry.getCache();
      }
      Http.prototype.getCookie = function (name) {
          var value = "; " + document.cookie;
          var parts = value.split("; " + name + "=");
          if (parts.length == 2) {
              return decodeURIComponent(parts.pop().split(';').shift());
          }
      };
      Http.prototype.fetchJsonResponse = function (config) {
          var _this = this;
          var url = Http.formatUrl(config);
          var fetchConfig = {
              method: config.method,
              mode: config.mode ? config.mode : 'cors',
              credentials: config.credentials ? config.credentials : 'include',
              headers: {},
          };
          // if (fetchConfig.credentials === 'include') {
          //   fetchConfig.headers['Access-Control-Allow-Origin'] = '*';
          //   fetchConfig.headers['Access-Control-Allow-Methods'] = 'GET, POST, PUT, DELETE, OPTIONS';
          //   fetchConfig.headers['Access-Control-Allow-Headers'] = 'Content-Type, Authorization, X-Requested-With';
          //   fetchConfig.headers['Access-Control-Allow-Credentials'] = true;
          // }
          if (config.data !== undefined && config.data !== null) {
              if (config.data instanceof FormData) {
                  fetchConfig.body = config.data;
                  // fetchConfig.headers['Content-Type'] = undefined;
                  fetchConfig.headers['Accept'] = '*/*';
              }
              else {
                  fetchConfig.body = config.data instanceof Object ? JSON.stringify(config.data) : config.data;
                  fetchConfig.headers['Accept'] = 'application/json, text/plain, */*';
                  fetchConfig.headers['Content-Type'] = 'application/json';
                  // XSRF-TOKEN handling
                  var xsrfToken = this.getCookie('XSRF-TOKEN');
                  if (xsrfToken) {
                      fetchConfig.headers['X-XSRF-TOKEN'] = xsrfToken;
                  }
              }
          }
          // Add or overwrite any headers that were passed in
          fetchConfig.headers = tslib_1.__assign(tslib_1.__assign({}, fetchConfig.headers), (config.headers ? config.headers : {}));
          // Clean up any undefined or null values from the object if explicitly set
          for (var _i = 0, _a = Object.entries(fetchConfig.headers); _i < _a.length; _i++) {
              var _b = _a[_i], key = _b[0], value = _b[1];
              if (value === undefined || value === null) {
                  delete fetchConfig.headers[key];
              }
          }
          return fetch(url, fetchConfig).then(function (resp) {
              if (_this.responseInterceptor) {
                  return _this.responseInterceptor(resp);
              }
              return resp;
          }).then(function (resp) {
              var _a, _b;
              if (!resp.ok) {
                  if ((_a = resp.headers.get('Content-Type')) === null || _a === void 0 ? void 0 : _a.includes('application/json')) {
                      return resp.json().then(function (data) {
                          // Extend response to include data
                          return Promise.reject(Object.assign(resp, { data: data }));
                      });
                  }
                  if ((_b = resp.headers.get('Content-Type')) === null || _b === void 0 ? void 0 : _b.includes('text/plain')) {
                      return resp.text().then(function (data) {
                          // Extend response to include data
                          return Promise.reject(Object.assign(resp, { data: data }));
                      });
                  }
                  return Promise.reject(Object.assign(resp, { data: null }));
              }
              if (resp.status === 204) {
                  return Promise.resolve(Object.assign(resp, { data: null }));
              }
              if (fetchConfig.method === 'HEAD') {
                  return Promise.resolve(Object.assign(resp, { data: null }));
              }
              var contentType = resp.headers.get('Content-Type');
              if (contentType === null || contentType === void 0 ? void 0 : contentType.includes('application/json')) {
                  return resp.json().then(function (data) {
                      // Extend response to include data
                      return Object.assign(resp, { data: data });
                  })
                      .catch(function (e) {
                      console.warn('HTTP: Failed to parse JSON response', e);
                      return Object.assign(resp, { data: null });
                  });
              }
              if ((contentType === null || contentType === void 0 ? void 0 : contentType.includes('text/plain')) || config.responseType === 'text') {
                  return resp.text().then(function (data) {
                      // Extend response to include data
                      return Object.assign(resp, { data: data });
                  });
              }
              return Promise.resolve(Object.assign(resp));
          });
      };
      Http.formatUrl = function (config) {
          var url = config.url;
          if (config.params) {
              if (url.includes('?')) {
                  url += '&';
              }
              else {
                  url += '?';
              }
              url += Http.getQueryString(config.params);
          }
          return url;
      };
      // Adapted from https://github.com/github/fetch/issues/256#issuecomment-271870897
      Http.getQueryString = function (params) {
          return Object.keys(params).map(function (k) {
              var param = params[k];
              if (Array.isArray(param)) {
                  return param
                      .map(function (val) { return encodeURIComponent(k) + "=" + encodeURIComponent(val); })
                      .join('&');
              }
              return encodeURIComponent(k) + "=" + encodeURIComponent(param);
          }).join('&');
      };
      Http.prototype.request = function (config) {
          var _this = this;
          if (config === void 0) { config = {}; }
          if (config.cache === true) {
              return this.config.cache.refreshIfAbsent(Http.formatUrl(config), function () {
                  return _this.fetchJsonResponse(config);
              });
          }
          if (config.cache === 'refresh') {
              return this.config.cache.refresh(Http.formatUrl(config), function () {
                  return _this.fetchJsonResponse(config);
              });
          }
          return this.fetchJsonResponse(config);
      };
      Http.prototype.serviceRequest = function (serviceName, path, config) {
          var _this = this;
          if (config === void 0) { config = {}; }
          return this.config.registry.getUrl(serviceName, path, config.version).then(function (url) {
              config.url = url;
              return _this.request(config);
          });
      };
      //
      // Shortcut methods
      //
      Http.prototype.get = function (serviceName, path, config) {
          if (config === void 0) { config = {}; }
          config.method = 'GET';
          return this.serviceRequest(serviceName, path, config);
      };
      Http.prototype.post = function (serviceName, path, data, config) {
          if (config === void 0) { config = {}; }
          config.method = 'POST';
          config.data = data;
          return this.serviceRequest(serviceName, path, config);
      };
      Http.prototype.put = function (serviceName, path, data, config) {
          if (config === void 0) { config = {}; }
          config.method = 'PUT';
          config.data = data;
          return this.serviceRequest(serviceName, path, config);
      };
      Http.prototype.patch = function (serviceName, path, data, config) {
          if (config === void 0) { config = {}; }
          config.method = 'PATCH';
          config.data = data;
          return this.serviceRequest(serviceName, path, config);
      };
      Http.prototype.delete = function (serviceName, path, config) {
          if (config === void 0) { config = {}; }
          config.method = 'DELETE';
          return this.serviceRequest(serviceName, path, config);
      };
      Http.prototype.head = function (serviceName, path, config) {
          if (config === void 0) { config = {}; }
          config.method = 'HEAD';
          return this.serviceRequest(serviceName, path, config);
      };
      Http.prototype.fetch = function (url, config) {
          if (config === void 0) { config = {}; }
          config.url = url;
          return this.fetchJsonResponse(config);
      };
      return Http;
  }());
  exports.default = Http;

  });

  var Preferences_1 = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", { value: true });

  var Http_1$1 = tslib_1.__importDefault(Http_1);
  var DEFAULT_CONFIG = {
      http: new Http_1$1.default(),
  };
  var Preferences = /** @class */ (function () {
      function Preferences(config) {
          if (config === void 0) { config = DEFAULT_CONFIG; }
          this.config = tslib_1.__assign(tslib_1.__assign({}, DEFAULT_CONFIG), config);
      }
      Preferences.prototype.get = function (path, cache) {
          if (path === void 0) { path = null; }
          if (cache === void 0) { cache = true; }
          var reqPath = 'preferences';
          if (path) {
              reqPath += '/' + path;
          }
          return this.config.http.get('portal_service', reqPath, { version: 2, cache: cache }).then(function (resp) {
              return resp.data;
          });
      };
      Preferences.prototype.update = function (prefs) {
          return this.config.http.put('portal_service', 'preferences', prefs, { version: 2 }).then(function (resp) {
              return resp.data;
          });
      };
      Preferences.prototype.patch = function (path, prefs) {
          return this.config.http.patch('portal_service', "preferences/" + path, prefs, { version: 2 }).then(function (resp) {
              return resp.data;
          });
      };
      Preferences.prototype.delete = function (path) {
          return this.config.http.delete('portal_service', "preferences/" + path, { version: 2 }).then(function (resp) {
              return resp.data;
          });
      };
      Preferences.prototype.deleteAll = function () {
          return this.config.http.delete('portal_service', 'preferences', { version: 2 });
      };
      return Preferences;
  }());
  exports.default = Preferences;

  });

  var Locale_1 = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", { value: true });
  var Locale = /** @class */ (function () {
      function Locale() {
          this.LOCALE_COOKIE_NAME = 'pos.rn.locale';
      }
      Locale.prototype.getCookieValue = function (cookieName) {
          var match = document.cookie.match(new RegExp('(^| )' + cookieName + '=([^;]+)'));
          if (match) {
              return decodeURIComponent(match[2]);
          }
          return null;
      };
      Locale.prototype.getBestFit = function () {
          var cookie = JSON.parse(this.getCookieValue(this.LOCALE_COOKIE_NAME));
          if (cookie && cookie.locale) {
              return cookie.locale.split('-')[0];
          }
          return window.navigator.language.split('-')[0];
      };
      return Locale;
  }());
  exports.default = Locale;

  });

  var dist = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", { value: true });
  exports.locale = exports.preferences = exports.http = exports.registry = exports.cache = void 0;

  var Cache_1$1 = tslib_1.__importDefault(Cache_1);
  var Registry_1$1 = tslib_1.__importDefault(Registry_1);
  var Http_1$1 = tslib_1.__importDefault(Http_1);
  var Preferences_1$1 = tslib_1.__importDefault(Preferences_1);
  var Locale_1$1 = tslib_1.__importDefault(Locale_1);
  // TODO: move into Registry and have it listen for blue ready
  function getRegistryHost() {
      var host = '';
      if (window.printos &&
          window.printos.blue &&
          window.printos.blue.ui &&
          window.printos.blue.ui.registry) {
          host = window.printos.blue.ui.registry.host;
      }
      return host;
  }
  exports.cache = new Cache_1$1.default();
  exports.registry = new Registry_1$1.default({
      cache: exports.cache,
      host: getRegistryHost(),
  });
  exports.http = new Http_1$1.default({
      cache: exports.cache,
      registry: exports.registry
  });
  exports.preferences = new Preferences_1$1.default({ http: exports.http });
  exports.locale = new Locale_1$1.default();
  exports.default = {
      cache: exports.cache,
      registry: exports.registry,
      http: exports.http,
      preferences: exports.preferences,
      locale: exports.locale,
  };

  });

  function add_css() {
    var style = element("style");
    style.id = "svelte-1if0avd-style";
    style.textContent = ".pros-icon-wrapper.svelte-1if0avd .pros-icon-content.svelte-1if0avd{display:flex;flex-direction:column;justify-content:center;align-items:center;line-height:unset}.pros-icon-wrapper.svelte-1if0avd .pros-icon-content.svelte-1if0avd svg{width:auto;height:100%}.pros-icon-wrapper[pos--mode=form].svelte-1if0avd.svelte-1if0avd{cursor:pointer;width:auto;height:48px;margin-left:8px;margin-bottom:20px;border-radius:4px}.pros-icon-wrapper[pos--mode=form].disabled.svelte-1if0avd.svelte-1if0avd{cursor:default}.pros-icon-wrapper[pos--mode=clickable].svelte-1if0avd.svelte-1if0avd{display:flex;flex-direction:column;justify-content:center;align-items:center;cursor:pointer;height:32px;width:32px;border-radius:4px}.pros-icon-wrapper[pos--mode=clickable].svelte-1if0avd .pros-icon-content.svelte-1if0avd{height:24px;width:auto}.pros-icon-wrapper[pos--mode=clickable].disabled.svelte-1if0avd.svelte-1if0avd{cursor:default}.pros-icon-wrapper[pos--mode=toolbar].svelte-1if0avd.svelte-1if0avd{cursor:pointer;width:auto;height:16px;margin-left:8px}.pros-icon-wrapper[pos--mode=toolbar].disabled.svelte-1if0avd.svelte-1if0avd{cursor:default}.pros-icon-wrapper[pos--theme=light].svelte-1if0avd.svelte-1if0avd{color:#212121}.pros-icon-wrapper[pos--theme=light].disabled.svelte-1if0avd.svelte-1if0avd{color:#adadad}.pros-icon-wrapper[pos--theme=light][pos--mode=clickable].svelte-1if0avd.svelte-1if0avd{color:#212121;background-color:transparent}.pros-icon-wrapper[pos--theme=light][pos--mode=clickable].svelte-1if0avd.svelte-1if0avd:hover{background-color:rgba(33, 33, 33, 0.05)}.pros-icon-wrapper[pos--theme=light][pos--mode=clickable].disabled.svelte-1if0avd.svelte-1if0avd{color:#adadad}.pros-icon-wrapper[pos--theme=light][pos--mode=button].svelte-1if0avd.svelte-1if0avd{color:inherit}.pros-icon-wrapper[pos--theme=dark].svelte-1if0avd.svelte-1if0avd{color:#ebebeb}.pros-icon-wrapper[pos--theme=dark].disabled.svelte-1if0avd.svelte-1if0avd{color:#585858}.pros-icon-wrapper[pos--theme=dark][pos--mode=clickable].svelte-1if0avd.svelte-1if0avd{color:#ffffff;background-color:transparent}.pros-icon-wrapper[pos--theme=dark][pos--mode=clickable].svelte-1if0avd.svelte-1if0avd:hover{background-color:rgba(33, 33, 33, 0.05)}.pros-icon-wrapper[pos--theme=dark][pos--mode=clickable].disabled.svelte-1if0avd.svelte-1if0avd{color:#585858}.pros-icon-wrapper[pos--theme=dark][pos--mode=button].svelte-1if0avd.svelte-1if0avd{color:inherit}";
    append(document.head, style);
  }

  // (3:4) {#if _content}
  function create_if_block(ctx) {
    var html_tag;
    var html_anchor;
    return {
      c: function c() {
        html_anchor = empty();
        html_tag = new HtmlTag(html_anchor);
      },
      m: function m(target, anchor) {
        html_tag.m(/*_content*/ctx[1], target, anchor);
        insert(target, html_anchor, anchor);
      },
      p: function p(ctx, dirty) {
        if (dirty & /*_content*/2) html_tag.p(/*_content*/ctx[1]);
      },
      d: function d(detaching) {
        if (detaching) detach(html_anchor);
        if (detaching) html_tag.d();
      }
    };
  }
  function create_fragment(ctx) {
    var div1;
    var div0;
    var div0_pros_tooltip_value;
    var div1_class_value;
    var if_block = /*_content*/ctx[1] && create_if_block(ctx);
    return {
      c: function c() {
        div1 = element("div");
        div0 = element("div");
        if (if_block) if_block.c();
        attr(div0, "class", "pros-icon-content svelte-1if0avd");
        attr(div0, "style", /*_style*/ctx[4]);
        attr(div0, "pros-tooltip", div0_pros_tooltip_value = /*tooltip*/ctx[6] || null);
        attr(div1, "class", div1_class_value = "pros-icon-wrapper " + /*_className*/ctx[3] + " svelte-1if0avd");
        attr(div1, "style", /*_style*/ctx[4]);
        attr(div1, "pos--theme", /*_theme*/ctx[2]);
        attr(div1, "pos--mode", /*mode*/ctx[0]);
        toggle_class(div1, "disabled", /*disabled*/ctx[7]);
      },
      m: function m(target, anchor) {
        insert(target, div1, anchor);
        append(div1, div0);
        if (if_block) if_block.m(div0, null);
        /*div1_binding*/
        ctx[22](div1);
      },
      p: function p(ctx, _ref) {
        var _ref2 = _slicedToArray(_ref, 1),
          dirty = _ref2[0];
        if (/*_content*/ctx[1]) {
          if (if_block) {
            if_block.p(ctx, dirty);
          } else {
            if_block = create_if_block(ctx);
            if_block.c();
            if_block.m(div0, null);
          }
        } else if (if_block) {
          if_block.d(1);
          if_block = null;
        }
        if (dirty & /*_style*/16) {
          attr(div0, "style", /*_style*/ctx[4]);
        }
        if (dirty & /*tooltip*/64 && div0_pros_tooltip_value !== (div0_pros_tooltip_value = /*tooltip*/ctx[6] || null)) {
          attr(div0, "pros-tooltip", div0_pros_tooltip_value);
        }
        if (dirty & /*_className*/8 && div1_class_value !== (div1_class_value = "pros-icon-wrapper " + /*_className*/ctx[3] + " svelte-1if0avd")) {
          attr(div1, "class", div1_class_value);
        }
        if (dirty & /*_style*/16) {
          attr(div1, "style", /*_style*/ctx[4]);
        }
        if (dirty & /*_theme*/4) {
          attr(div1, "pos--theme", /*_theme*/ctx[2]);
        }
        if (dirty & /*mode*/1) {
          attr(div1, "pos--mode", /*mode*/ctx[0]);
        }
        if (dirty & /*_className, disabled*/136) {
          toggle_class(div1, "disabled", /*disabled*/ctx[7]);
        }
      },
      i: noop,
      o: noop,
      d: function d(detaching) {
        if (detaching) detach(div1);
        if (if_block) if_block.d();
        /*div1_binding*/
        ctx[22](null);
      }
    };
  }
  function hasValue(test) {
    return test !== undefined && test !== null;
  }
  function instance($$self, $$props, $$invalidate) {
    createEventDispatcher();
    var _$$props$name = $$props.name,
      name = _$$props$name === void 0 ? null : _$$props$name; // Name of veneer image (E.G. 'alarm')
    var _$$props$path = $$props.path,
      path = _$$props$path === void 0 ? null : _$$props$path; // Path relative to 'https://cdn/printos.com/images' image (E.G. 'veneer/alarm-o.svg')
    var _$$props$url = $$props.url,
      url = _$$props$url === void 0 ? null : _$$props$url; // Full url of hosted image (E.G. 'https://cdn.printos.com/images/veneer/alarm-o.svg')
    var _$$props$theme = $$props.theme,
      theme = _$$props$theme === void 0 ? "auto" : _$$props$theme; // Color Theme (auto/dark/light)
    var _$$props$mode = $$props.mode,
      mode = _$$props$mode === void 0 ? "default" : _$$props$mode; // default/form
    var _$$props$className = $$props.className,
      className = _$$props$className === void 0 ? "" : _$$props$className; // Class name
    var tooltip = $$props.tooltip;
    var _$$props$disabled = $$props.disabled,
      disabled = _$$props$disabled === void 0 ? false : _$$props$disabled;
    var _$$props$size = $$props.size,
      size = _$$props$size === void 0 ? "24px" : _$$props$size;
    var _$$props$constraint = $$props.constraint,
      constraint = _$$props$constraint === void 0 ? "h" : _$$props$constraint;
    var color = $$props.color;
    var _$$props$solid = $$props.solid,
      solid = _$$props$solid === void 0 ? false : _$$props$solid;
    var _$$props$_content = $$props._content,
      _content = _$$props$_content === void 0 ? undefined : _$$props$_content;
    var _theme = $$props._theme;
    var _lastTheme = $$props._lastTheme;
    var _className = $$props._className;
    var _$$props$_style = $$props._style,
      _style = _$$props$_style === void 0 ? "" : _$$props$_style;
    var _$$props$_iconElement = $$props._iconElement,
      _iconElement = _$$props$_iconElement === void 0 ? undefined : _$$props$_iconElement;
    var _$$props$_lastName = $$props._lastName,
      _lastName = _$$props$_lastName === void 0 ? null : _$$props$_lastName;
    var _$$props$_lastPath = $$props._lastPath,
      _lastPath = _$$props$_lastPath === void 0 ? null : _$$props$_lastPath;
    var _$$props$_lastUrl = $$props._lastUrl,
      _lastUrl = _$$props$_lastUrl === void 0 ? null : _$$props$_lastUrl;
    onMount(function () {
      $$invalidate(3, _className = hasValue(className) ? className : "");
      updateContent();
    }); // setTimeout(() => {_iconElement.parentElement.style.width = 'auto';});

    beforeUpdate(function () {
      $$invalidate(8, theme = hasValue(theme) ? theme : "light");
      $$invalidate(0, mode = hasValue(mode) ? mode : "icon");
      if (theme !== _lastTheme) {
        $$invalidate(9, _lastTheme = theme);
        if (theme === "auto") {
          var themeAttribute = window.document.body.getAttribute("pos--theme");
          $$invalidate(2, _theme = themeAttribute ? themeAttribute : "light");
          window.removeEventListener("posh-theme-changed", handleThemeChanged);
          window.addEventListener("posh-theme-changed", handleThemeChanged);
        } else {
          $$invalidate(2, _theme = theme);
        }
      }
      if (name !== _lastName) {
        $$invalidate(10, _lastName = name);
        updateContent();
      }
      if (path !== _lastPath) {
        $$invalidate(11, _lastPath = path);
        updateContent();
      }
      if (url !== _lastUrl) {
        $$invalidate(12, _lastUrl = url);
        updateContent();
      }
    });
    onDestroy(function () {
      window.removeEventListener("posh-theme-changed", handleThemeChanged);
    });
    function updateContent() {
      if (name) {
        var myName = solid ? name : "".concat(name, "-o");
        loadContent.call(this, "https://cdn.printos.com/images/general/veneer/".concat(myName, ".svg"));
      } else if (path) {
        var myPath = path.endsWith(".svg") ? path : "".concat(path, ".svg");
        loadContent.call(this, "https://cdn.printos.com/images/".concat(myPath));
      } else if (url) {
        loadContent.call(this, url);
      }
    }
    function handleThemeChanged(event) {
      if (theme === "auto") {
        $$invalidate(2, _theme = event.detail.theme);
      }
    }

    // Others
    function loadContent(url) {
      var config = {
        url: url,
        cache: true,
        credentials: "omit",
        responseType: "text"
      };
      return dist.http.request(config).then(function (resp) {
        $$invalidate(1, _content = resp.data);
      });
    }
    function div1_binding($$value) {
      binding_callbacks[$$value ? "unshift" : "push"](function () {
        _iconElement = $$value;
        $$invalidate(5, _iconElement);
      });
    }
    $$self.$$set = function ($$props) {
      if ("name" in $$props) $$invalidate(13, name = $$props.name);
      if ("path" in $$props) $$invalidate(14, path = $$props.path);
      if ("url" in $$props) $$invalidate(15, url = $$props.url);
      if ("theme" in $$props) $$invalidate(8, theme = $$props.theme);
      if ("mode" in $$props) $$invalidate(0, mode = $$props.mode);
      if ("className" in $$props) $$invalidate(16, className = $$props.className);
      if ("tooltip" in $$props) $$invalidate(6, tooltip = $$props.tooltip);
      if ("disabled" in $$props) $$invalidate(7, disabled = $$props.disabled);
      if ("size" in $$props) $$invalidate(17, size = $$props.size);
      if ("constraint" in $$props) $$invalidate(18, constraint = $$props.constraint);
      if ("color" in $$props) $$invalidate(19, color = $$props.color);
      if ("solid" in $$props) $$invalidate(20, solid = $$props.solid);
      if ("_content" in $$props) $$invalidate(1, _content = $$props._content);
      if ("_theme" in $$props) $$invalidate(2, _theme = $$props._theme);
      if ("_lastTheme" in $$props) $$invalidate(9, _lastTheme = $$props._lastTheme);
      if ("_className" in $$props) $$invalidate(3, _className = $$props._className);
      if ("_style" in $$props) $$invalidate(4, _style = $$props._style);
      if ("_iconElement" in $$props) $$invalidate(5, _iconElement = $$props._iconElement);
      if ("_lastName" in $$props) $$invalidate(10, _lastName = $$props._lastName);
      if ("_lastPath" in $$props) $$invalidate(11, _lastPath = $$props._lastPath);
      if ("_lastUrl" in $$props) $$invalidate(12, _lastUrl = $$props._lastUrl);
    };
    $$self.$$.update = function () {
      if ($$self.$$.dirty & /*size, constraint, color, _style*/917520) {
        // onState
        {
          if (size) {
            var h;
            var w;
            switch (constraint) {
              case "b":
                h = isNaN(size) ? size : "".concat(size, "px");
                w = isNaN(size) ? size : "".concat(size, "px");
                break;
              case "w":
                w = isNaN(size) ? size : "".concat(size, "px");
                h = "fit-content";
                break;
              case "h":
              default:
                h = isNaN(size) ? size : "".concat(size, "px");
                w = "fit-content";
                break;
            }
            $$invalidate(4, _style = "height:".concat(h, ";width:").concat(w, ";"));
          }
          if (color) {
            if (hasValue(color)) {
              $$invalidate(4, _style += "color:".concat(color, ";fill:").concat(color));
            }
          }
        }
      }
    };
    return [mode, _content, _theme, _className, _style, _iconElement, tooltip, disabled, theme, _lastTheme, _lastName, _lastPath, _lastUrl, name, path, url, className, size, constraint, color, solid, hasValue, div1_binding];
  }
  var Icon = /*#__PURE__*/function (_SvelteComponent) {
    function Icon(options) {
      var _this;
      _classCallCheck(this, Icon);
      _this = _callSuper(this, Icon);
      if (!document.getElementById("svelte-1if0avd-style")) add_css();
      init(_this, options, instance, create_fragment, safe_not_equal, {
        name: 13,
        path: 14,
        url: 15,
        theme: 8,
        mode: 0,
        className: 16,
        tooltip: 6,
        disabled: 7,
        size: 17,
        constraint: 18,
        color: 19,
        solid: 20,
        _content: 1,
        _theme: 2,
        _lastTheme: 9,
        _className: 3,
        _style: 4,
        _iconElement: 5,
        _lastName: 10,
        _lastPath: 11,
        _lastUrl: 12,
        hasValue: 21
      });
      return _this;
    }
    _inherits(Icon, _SvelteComponent);
    return _createClass(Icon, [{
      key: "hasValue",
      get: function get() {
        return hasValue;
      }
    }]);
  }(SvelteComponent);

  exports.Icon = Icon;

  Object.defineProperty(exports, '__esModule', { value: true });

})));
